import React, { Component } from 'react';
import {Link} from 'react-router-dom'
class BannerTitle extends Component {
    render() {
        return (null        );
    }
}

export default BannerTitle;